import { all, takeLatest } from "redux-saga/effects";

import { SimuladorPrevidenciaTypes } from "../ducks/simuladorPrevidencia";

import {
  consultarContribuicaoMaximaRequest,
  consultarSimulacaoRequest,
  consultarContribuicaoBasica
} from "./simuladorPrevidencia";

export default function* rootSaga() {
  yield all([

    takeLatest(
      SimuladorPrevidenciaTypes.CONSULTAR_CONTRIBUICAO_MAXIMA_REQUEST,
      consultarContribuicaoMaximaRequest
    ),

    takeLatest(
      SimuladorPrevidenciaTypes.CONSULTAR_SIMULACAO_REQUEST,
      consultarSimulacaoRequest
    ),

    takeLatest(
      SimuladorPrevidenciaTypes.CONSULTAR_CONTRIBUICAO_BASICA,
      consultarContribuicaoBasica
    )

  ]);
}
